import styled, { css } from "styled-components";

export const TooltipSpanTitlePart = styled.span`
	word-break: keep-all;
`;

interface ISpanTitlePartProps {
	$showIcon?: boolean;
	$isEllipsisText?: boolean;
	$hasTrailingIcon?: boolean;
}

export const SpanTitlePart = styled.span<ISpanTitlePartProps>`
	display: flex;
	align-items: center;
	min-width: 0;
	width: 100%;

	.text-with-icon {
		display: inline-flex;
		align-items: center;
		gap: 2px;

		max-width: 100%;
		min-width: 0;
	}

	.text-with-icon .text {
		display: block;
		flex: 1 1 auto;
		min-width: 0;

		${({ $isEllipsisText }) =>
			$isEllipsisText
				? css`
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					`
				: css`
						word-break: break-word;
						white-space: normal;
						overflow: visible;
					`}
	}

	.text-with-icon .icon {
		flex-shrink: 0;
		display: flex;
		align-items: center;
	}

	${({ $hasTrailingIcon }) =>
		$hasTrailingIcon &&
		css`
			> .text-content {
				min-width: 0;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			> .icon {
				flex-shrink: 0;
				display: flex;
				align-items: center;
			}
		`}
`;

export const ContainerQuoteProcurementPartInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-width: 0;
	overflow: hidden;

	> h6 {
		margin: 0;
	}

	.supplierInventoryPartName,
	.supplierInventoryPartTitle {
		min-width: 0;
		overflow: hidden;
		width: 100%;

		> ${SpanTitlePart} {
			width: 100%;
		}
	}
`;

export const AreaRenderQuoteItemInformation = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	overflow: hidden;
	min-width: 0;
	width: 100%;

	> ${SpanTitlePart} {
		flex: 1;
		min-width: 0;
	}

	.icon-wrapper {
		flex-shrink: 0;
		display: flex;
		align-items: center;
	}
`;
